import Home from "./Home";
import About from "./About";
import ContactBlock from "./Contacts";
import Cookshop from "./Cookshop";
import Vsos from "./Vsos";
import Training from "./Training";
import Camp from "./Camp";
import Centraddedu from "./Centraddedu";
import Documents from "./Documents";
import Layout from "./Layout"
import {createTheme, ThemeProvider} from "@mui/material";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './App.css';


const theme = createTheme({
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: 'rgba(21,112,169,0.9)',
                    textDecoration: 'none',
                    '&:hover': {
                        color: 'rgba(41,56,113,0.9)',
                        textDecoration: 'Navbar',
                    },
                },
            },
        },
    },
});


function App() {
    document.cookie = "special=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="about" element={<About/>}/>
                        <Route path="contacts" element={<ContactBlock/>}/>
                        <Route path="food" element={<Cookshop/>}/>
                        <Route path="training" element={<Training/>}/>
                        <Route path="camp" element={<Camp/>}/>
                        <Route path="centraddedu" element={<Centraddedu/>}/>
                        <Route path="documents" element={<Documents/>}/>
                        <Route path="vsos" element={<Vsos/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
